var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.$t('eventChat.buttonTitle'),
    classes: ['vue-tooltip-dark', 'vue-tooltip-dark-noarrow', 'vue-tooltip-dark-eventchat'],
    placement: 'left',
    delay: 0,
  }),expression:"{\n    content: $t('eventChat.buttonTitle'),\n    classes: ['vue-tooltip-dark', 'vue-tooltip-dark-noarrow', 'vue-tooltip-dark-eventchat'],\n    placement: 'left',\n    delay: 0,\n  }"}],staticClass:"event-chat-button",on:{"click":_vm.onClick}},[_c('icon-event-chat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }